const lookup = [
    { value: 1e18, digits: 2, symbol: "E" },
    { value: 1e15, digits: 2, symbol: "P" },
    { value: 1e12, digits: 2, symbol: "T" },
    { value: 1e9, digits: 2, symbol: "B" },
    { value: 1e6, digits: 2, symbol: "M" },
    { value: 1e3, digits: 3, symbol: "" },
    { value: 1, digits: 0, symbol: "" },
];

/**
 * Formats a number with abbreviated suffixes for large values.
 *
 * - Values >= 1B display with "B" suffix (e.g. `1.23 B`)
 * - Values >= 1M display with "M" suffix (e.g. `4.56 M`)
 * - Values >= 1K display with comma notation (e.g. `1,234`)
 * - Values < 1K display as-is (e.g. `42`)
 *
 * @param num - The number to format.
 * @param digits - Optional decimal precision override.
 * @returns The formatted string representation.
 */
export function numberPrettyFormatter(num: number | undefined, digits: number | undefined = undefined): string {
    if (!num) {
        return "0";
    }
    const item = lookup.find(function (item) {
        return num >= item.value;
    });
    if (!item) {
        return num.toFixed(digits ?? 2);
    }
    let retNum = `${(num / item.value).toFixed(digits || item.digits)}${item.symbol ? " " + item.symbol : ""}`;
    if (item.symbol === "") {
        retNum = retNum.replace(".", ",");
    }
    return retNum;
}
